import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import { useAddProjectModal } from "@/modals/ProjectModal";
import { useDialog } from "@imminently/decisively-ui/Dialog";
import { WORKSPACE_LAYER } from "@/ui/dialogs/layers";
import { useScope } from "@/redux/scope";

import { CreateProjectPrompt } from "../components/CreateProjectPrompt";

// build needs an active release to work; a project is just the parent of a release,
// and every project always has at least one release. In practice, there's only ever
// a genuine gap here on initial app setup, a brand-new workspace, or after a user
// deletes every project in a workspace - not on every navigation, so this hook is
// meant to be mounted once per scoped route-group rather than per page.
export const useProjectReleaseGuard = () => {
  const dispatch = useDispatch();
  const openAddProject = useAddProjectModal();
  const { pushDialog } = useDialog();
  const { workspace, project: projectId, release: releaseId, releasePending, projectPending } = useScope();

  // workspace must be known before we can trust an absent project - during cold
  // start / tenancy switch, workspace/project/pending are all momentarily undefined
  const hasNoProject = Boolean(workspace) && !projectId && !projectPending;
  const hasNoRelease = Boolean(projectId) && !releaseId && !releasePending;
  const shouldPromptCreateProject = hasNoProject || hasNoRelease;

  useEffect(() => {
    if (!shouldPromptCreateProject) return;

    pushDialog({
      layer: WORKSPACE_LAYER,
      options: { intent: "form" },
      component: (props) => (
        <CreateProjectPrompt
          {...props}
          onCreateProject={openAddProject}
          onViewProjects={() => dispatch(push("/projects"))}
        />
      ),
    });
  }, [dispatch, shouldPromptCreateProject, openAddProject, pushDialog]);
};
